import React from "react";
import './channels.css'
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import SglContext from "../SglContext";
import { Link } from "react-router-dom";
const site_url = "//" + window.location.host;


// const sgl_webservice_video_to_play =
//   Sgl.nestApiUrl + "/videos/play/";


function LiveStream(props) {
  const [is_user_authorized, setIs_user_authorized] = useState(false)
  const [total_rows, setTotal_rows] = useState(0)
  const [channels_list, setChannels_list] = useState([])
  // const [is_mobile, setIs_mobile] = useState(false)
  const [loading, setLoading] = useState(true)
  const [userData, setUserData] = useState({})
  const [login_people_id, setLogin_people_id] = useState(-1)
  const [switch_allowed, setSwitch_allowed] = useState(0)
  const [switch_company_name, setSwitch_company_name] = useState('')

  const Sgl = useContext(SglContext)

  const sgl_webservice_channels_list = Sgl.nestApiUrl + "/video-assets/getLiveRingStreamsList";
  const user_info_url = Sgl.nestApiUrl + "/users/getUser";
  
  useEffect(() => {
    var switches = Sgl.switches.switches;
    var switch_found = switches.find(el => el.switch_name === "Videos - Live Ring Streams");
    var switch_allowed = 0;
    if(switch_found){
      console.log(switch_found.switch_name, switch_found.value);
      switch_allowed = switch_found.value;
    }
    setSwitch_allowed(switch_allowed);
    
    if(switch_allowed){
      getChannelsData();
    } else {
      setSwitch_company_name(Sgl.company_name ? Sgl.company_name : 'The Company');
      setLoading(false);
    }
  }, [])

  function getChannelsData() {

    axios
      .get(sgl_webservice_channels_list, {
        params: {
          channel_type: 'livestream',
          customer_id: Sgl.company_id,
        },
      })
      .then((res) => {
        Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_urlpath + '/channels/live/list');
        Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_urlpath + '/channels/live/list');
        setChannels_list(res.data.channels_list)
        setTotal_rows(res.data.total_records)
        setLoading(false)
      });
  }


  function getUserData() {
    axios.get(user_info_url).then(
      (response) => {
        if (response.data.user && response.data.user != null) {
          setUserData(response.data.user)
          setLogin_people_id(response.data.user.sgl_id)
        }
      },
      (error) => { }
    );

  }

  function onChangePage(page) {
    getChannelsData();
  }

  if (loading) {
    return null;
  }
  
  if(switch_allowed != 1){
    return(
      <div>
        <h2>Live Ring Streams</h2>
        <p>{switch_company_name + ' does not support this feature.'}</p>
      </div>
    )
  }
  
  return (
    <div className="sgl-plugin section-to-print livestreamcss">
      {/* <div className=''>
          <h1>Live Ring Streams </h1>
        </div>
        <div>
            <p className='channel_description'>
                Welcome to the ShowGroundsLive.com Video Channels!
                <br/><br/>
                This service will allow access to live ring streaming when rings are active and underway. 
                <br/><br/>
                We hope you enjoy the service and we welcome your feed back at suggestions@showgroundslive.com.
            </p>
        </div> */}
      <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />
      <div
        id="channels_listing" className='grid'
      >
        <div className="flex-video-container">

          {total_rows > 0 ? (
            channels_list.map((channel, index) => {
              return (
                <div key={index} className="video_container ">
                  <div className="video-content">

                    <div className="thumb-image">
                      <Link className='cursor-pointer' to={'/live-channels/detail?live_channel=' + channel.sgl_id}>
                        { channel.logo && <img class='display_thumb_img' src={channel.logo} />}
                        <div className={(channel.status == 'Online') ? 'green channel_status' : 'red channel_status'}>
                          {(channel.status == 'Online') ? "LIVE" : "OFFLINE"}
                        </div>
                      </Link>
                    </div>
                    <div className="video_details">

                      <div>
                        <Link className='cursor-pointer' to={'/live-channels/detail?live_channel=' + channel.sgl_id}>
                          <span className="channel_details link_color">
                            {channel.name}
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="video_container ">
              <div className="video-content">
                <div className="thumb-image">
                  {/* <img src={horse_logo} /> */}
                  <span className="float-left">No channels Found</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
    </div>
  );
  // }
}
export default LiveStream